import { Icon } from '@mui/material';
import mapboxgl from 'mapbox-gl';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const Marker = ({ map, feature, isActive, onClick }) => {
    const data = feature;
    const markerRef = useRef();
    const contentRef = useRef(document.createElement('div'));

    useEffect(() => {
        // const coords = JSON.parse(Number(data.Long), Number(data.Lat));
        // console.log(coords)
        markerRef.current = new mapboxgl.Marker()
            .setLngLat([data.Long, data.Lat]).addTo(map)

        return () => {
            markerRef.current.remove();
        }
    }, [])
    // return null;
    return (
        <>
            {createPortal(
                <div onClick={() => onClick(feature)} className='shop_marker' style={{
                    display: "inline-block",
                    padding: "2px 10px",
                    borderRadius: "50px",
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#333",
                    textAlign: "center",
                }}>
                    {/* <Icon></Icon> */}
                    <div>{data.Name}</div>
                </div>, contentRef.current
            )}
        </>
    )
}

export default Marker;